module.exports = __webpack_public_path__ + "img/refresh.a9b77cfb.svg";